import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReplacementFilesComponentDocumentsDto, Resubmitter } from '@cambridgeassessment/lib-ee-commons';
import { setComponentDocumentReplacementStatus } from '../../../../../store/replacementFiles/thunks';
import ToggleRow from './ToggleRow';
import { useAuth } from 'oidc-react';
import { RootState } from '../../../../../store';

interface Props {
  document: ReplacementFilesComponentDocumentsDto;
  componentIndex: number;
}

export const ToggleRowDocument: React.FC<Props> = ({ componentIndex, document }) => {
  const dispatch = useDispatch();
  const { userData } = useAuth();
  const { selectedRole } = useSelector((state: RootState) => state.userData);

  const onSubmissionToggle = (isToggleOn: boolean): void => {
    const resubmitter: Resubmitter | undefined = isToggleOn
      ? {
          name: userData?.profile.name,
          email: userData?.profile.email,
          role: selectedRole?.name,
        }
      : undefined;
    dispatch(setComponentDocumentReplacementStatus(componentIndex, document, resubmitter));
  };

  return (
    <ToggleRow
      qaId={`toogle-document-${document.assessment.code}-${document.componentNumber}-${document.section.id}`}
      title={document.section.name}
      resubmission={document.resubmission}
      onChange={onSubmissionToggle}
    />
  );
};

export default ToggleRowDocument;
